<header class="ib-modals__header">
  <div class="ib-layout__line-spacing ib-layout__line-spacing--xsmall">
    <h2 class="ib-heading ib-heading--type-1">
      <span class="ib-heading__icon icon-alertas"></span>
      <span class="ib-heading__text">{{'MODAL_ERROR_TITLE_VOUCHER'|translate}}</span>
    </h2>
  </div>
  <div class="ib-modals__header-settings">
    <button id="pmt-generic-error-modal-close-btn" type="button" class="ib-modals__button-action icon-cerrar" (click)="close()">
      <span class="u-hide-accessible">{{'MODAL_HIDDEN_CLOSE_TEXT'|translate}}</span>
    </button>
  </div>
</header>
<section id="pmt-generic-error-modal" class="ib-modals__body">
  <div class="ib-layout__line-spacing ib-layout__line-spacing--large QM-modal__error__body">
    <p class="ib-text">{{model.body|translate}}</p>
  </div>
</section>
<footer class="ib-modals__footer">
  <div class="ib-content-buttons">
    <div class="ib-content-buttons__content-right">
          <a id="MOD_ERROR_BOTON_CLOSE" class="ib-link" (click)="close()">{{'MODAL_CANCEL_BUTTON_VOUCHER'|translate}}</a>
      </div>
      <div class="ib-content-buttons__content-left">
        <button id="MOD_ERROR_BOTON_ACEP" title="{{'MODAL_ACCEPT_BUTTON'|translate}}" class="ib-button ib-button--w-medium" (click)="close()">{{'MODAL_ACCEPT_VOUCHER'|translate}}</button>
      </div>
  </div>  
</footer>

